
document.addEventListener("turbo:load", function() {
  let toggableIndustriesButton = document.querySelector("[data-js-id=js-industries-toggle-button")
  let toggableIndustriesContainer = document.querySelector("[data-js-id=js-industries-toggle-container")

  if (!!toggableIndustriesButton) {
    $(toggableIndustriesButton).click(function (e) {
      e.preventDefault()

      if (!!toggableIndustriesContainer) {
        $(toggableIndustriesContainer).toggle();
      }
    });
  }
})
